import Vue from 'vue'
import VueRouter from 'vue-router'
import interceptors from './interceptors'; // 路由拦截器

Vue.use(VueRouter)
let routes = [
  {
    path: '/',
    redirect: '/login',
    meta: {
      default: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta:{
    },
  }, 
  {
    path: '/system',
    name: 'system-manage',
    component: () => import('@/components/manage/index.vue'),
    meta:{
    },
    children: [
      {
        path: 'structure',
        name: 'structure',
        component: () => import('@/components/manage/organ-structure/index.vue'),
        meta: {
          title: '内部组织'
        }
      },
      {
        path: 'external-structure',
        name: 'external-structure',
        component: () => import('@/components/manage/external-structure/index.vue'),
        meta: {
          title: '外部组织'
        }
      },
      {
        path: 'product-manage',
        name: 'product-manage',
        component: () => import('@/components/manage/product-manage/index.vue'),
        meta: {
          title: '产品管理',
        },
      },
      {
        path: 'system-log',
        name: 'system-log',
        component: () => import('@/components/manage/system-log/index.vue'),
        meta: {
          title: '系统日志',
        },
      },
      {
        path: 'operation-log',
        name: 'operation-log',
        component: () => import('@/components/manage/operation-log/index.vue'),
        meta: {
          title: '应用日志',
        },
      },
      {
        path: 'resource-monitor',
        name: 'resource-monitor',
        component: () => import('@/components/manage/resource-monitor/index.vue'),
        meta: {
          title: '资源监控',
        },
      },
    ]
  }, 
  {
    path: '/product-manage',
    name: 'product-manage',
    component: () => import('@/components/manage/product-manage/index.vue'),
    meta: {
      title: '产品管理',
    },
  }, 
]

//防止重复点击控制台报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
};
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch((err) => err)
};

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})
router.beforeEach(interceptors);
export default router
